<div class="row">
  <div
    [class]="config?.responsiveClassName || 'md:tw-w-1/2'"
    class="tw-px-1"
  ></div>

  <!-- start time picker -->
  <div [class]="config?.responsiveClassName || 'md:tw-w-1/2'" class="tw-px-1">
    <timepicker
      [label]="config?.startTimeLabel"
      [control]="config?.startTimeControlName"
      [maxTime]="maxStartTime"
      [value]="startTime"
      (value)="startTime = $event; combineDateAndTime(); setMinMaxTime()"
    >
    </timepicker>
  </div>

  <div
    [class]="config?.responsiveClassName || 'md:tw-w-1/2'"
    class="tw-px-1"
  ></div>

  <!-- end time picker -->
  <div [class]="config?.responsiveClassName || 'md:tw-w-1/2'" class="tw-px-1">
    <timepicker
      [label]="config?.endTimeLabel"
      [control]="config?.endTimeControlName"
      [minTime]="minEndTime"
      [value]="endTime"
      (value)="endTime = $event; combineDateAndTime(); setMinMaxTime()"
      [confirmBtnClass]="'btn' | themeColor"
    >
    </timepicker>
  </div>

  <span class="text-danger" *ngIf="isShowError">
    *
    {{ "messages.periodDateTimeErrorMsg" | translate }}
  </span>
</div>
